import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_djzznyju1u: FaireBrandEntity = {
  token: "b_djzznyju1u",
  type: "brand",
  name: "Little Joy Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/c0f538584cd0a2b45f1064f1fe3b6f88b4016c697346f28ef6f4d2c9498b7b72.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a5ac0a91f453c8b0d9eec328c705c1f52a12799104fb2d1f49861db8e9b1b6d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c0f538584cd0a2b45f1064f1fe3b6f88b4016c697346f28ef6f4d2c9498b7b72.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a5ac0a91f453c8b0d9eec328c705c1f52a12799104fb2d1f49861db8e9b1b6d.png",
  location: "Ipswich, MA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 51,
  isInsider: true,
  description:
    "Little Joy Co. was started in 2020 by Elise, the mother of three (now four) young children, including a set of triplets. We started as a small shop with big dreams and are continuing to grow and expand our product lines. All products are carefully designed by Elise to ensure quality, safety, and overall value.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.014Z",
    importedBy: "entity-db-cli",
  },
};
